import { render, staticRenderFns } from "./SearchGoods.vue?vue&type=template&id=142f021a&scoped=true&"
import script from "./SearchGoods.vue?vue&type=script&lang=js&"
export * from "./SearchGoods.vue?vue&type=script&lang=js&"
import style0 from "./SearchGoods.vue?vue&type=style&index=0&id=142f021a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f021a",
  null
  
)

export default component.exports